/* eslint-disable @ms/forbid-file-names */
export const basenameForWebApp = '/main';
export const basenameForEmbedApp = '/embed';
export const basenameForTeamsApp = '/teams';
export const basenameForTeamsTabApp = '/teamstab';
export const basenameForTeamsMeetingApp = '/teamsmeeting';
export const basenameForTeamsNativeApp = '/teamsnative';

const basenames = [
  basenameForWebApp,
  basenameForTeamsApp,
  basenameForEmbedApp,
  basenameForTeamsTabApp,
  basenameForTeamsMeetingApp,
  basenameForTeamsNativeApp,
];

export type GetBasenames = () => string[];
export const getBasenames: GetBasenames = () => basenames;
